import { render, staticRenderFns } from "./SysAnnouncementList.vue?vue&type=template&id=1be50358&scoped=true"
import script from "./SysAnnouncementList.vue?vue&type=script&lang=js"
export * from "./SysAnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./SysAnnouncementList.vue?vue&type=style&index=0&id=1be50358&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be50358",
  null
  
)

export default component.exports